import { render, staticRenderFns } from "./allPersons.vue?vue&type=template&id=4a2b649e&scoped=true"
import script from "./allPersons.vue?vue&type=script&lang=js"
export * from "./allPersons.vue?vue&type=script&lang=js"
import style0 from "./allPersons.vue?vue&type=style&index=0&id=4a2b649e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2b649e",
  null
  
)

export default component.exports